import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProcessorReportsService, ProcessorReport } from 'src/app/services/processor-reports.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-processor-report-dialog',
  templateUrl: './processor-report-dialog.component.html',
  styleUrls: ['./processor-report-dialog.component.less']
})
export class ProcessorReportDialogComponent implements OnInit,OnDestroy {

  report : ProcessorReport;
  processing : boolean;
  constructor(public modalRef: NgbModal, public procRpts : ProcessorReportsService, public auth: AuthService) { }
  ngOnDestroy(): void {
    this.modalRef.dismissAll();
  }

  ngOnInit(): void {
  }

}
